// src/services/productService.js
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000";

// Fetch products for customers (shop frontend)
export const fetchProducts = async () => {
  try {
    const res = await axios.get(`${API_URL}/api/products`);
    return res.data;
  } catch (err) {
    console.error(
      "Error fetching products:",
      err.response?.data || err.message,
    );
    return [];
  }
};
